import { useEffect, useRef } from 'react'
import {
  isTopPostVideoMediaUrl,
  topPostVideoPreviewSrc,
} from '../../../lib/utils/topPostsReport'

export default function TopPostThumbnailMedia({ src }) {
  const videoRef = useRef(null)
  const isVideo = isTopPostVideoMediaUrl(src)

  useEffect(() => {
    if (!isVideo) return undefined
    const video = videoRef.current
    if (!video) return undefined

    const seekToPreview = () => {
      try {
        if (Number.isFinite(video.duration) && video.duration > 0.15) {
          video.currentTime = 0.1
        }
      } catch {
        // Ignore seek errors from short or incomplete media.
      }
    }

    video.addEventListener('loadeddata', seekToPreview)
    return () => video.removeEventListener('loadeddata', seekToPreview)
  }, [src, isVideo])

  if (!src) return <div className="topPostThumbnailPlaceholder" />

  if (isVideo) {
    return (
      <video
        ref={videoRef}
        src={topPostVideoPreviewSrc(src)}
        muted
        playsInline
        preload="metadata"
        onError={(event) => {
          event.currentTarget.style.display = 'none'
        }}
      />
    )
  }

  return <img src={src} alt="" loading="lazy" />
}
